'use strict';

module.exports = {
  SETUP_WIZARD_STATUS: 509,
  DISPLAY_NAME_1: 0,
  DISPLAY_NAME_2: 20, // host name
  COMPANY_NAME: 253, // legal name
  HOME_URL: 72,
  EMAIL_SUBSCRIBE: 24,
  CONTACT_EMAIL: 25,
  MANAGE_DOMAINS_URL: 47,
  MOBILE_STOREFRONT_ENABLED: 388,

  ROUND_UP_FOR_CHARITY_PROMO: 575,
  INDIA_CPANEL_PROMO: 1506,
  INDIA_PRODUCT_SALE_PROMO: 1518,
  CO_REGISTRATION_SALE_PROMO: 381,
  MOBI_REGISTRATION_SALE_PROMO: 590,
  ME_REGISTRATION_SALE_PROMO: 353,
  ORG_REGISTRATION_SALE_PROMO: 259,
  INFO_REGISTRATION_SALE_PROMO: 298,
  FREE_PRIVATE_REGISTRATION_PROMO: 304,
  DOMAINS_BY_PROXY_SALE_PROMO: 274,
  INDIA_DOMAIN_SALE_PROMO: 1516,
  BLACK_FRIDAY_DEALS: 1502,
  RADIX_DOMAINS_REGISTRATION_SALE: 1530,
  NEW_WEBSITE_BUILDER_PROMO: 1558,
  YEAR_LONG_DOMAIN_PROMOTION: 1559,
  YEARLY_TERMS_HOSTING_PROMO: 1560,
  SECURITY_BUNDLE_PROMO: 1562,
  INDIA_OX_PROMO: 1564,
  XYZ_REGISTRATION_SALE: 12525,
  COVID_19_RELIEF_PROMO_20_PERCENT: 1565,
  COVID_19_RELIEF_PROMO_35_PERCENT: 1566,

  CUSTOM_TEXT: 106,
  RECEIPT_OPTION: 107,
  ORDER_NOTIFY: 29,

  SUPPORTING_OPTION: 44,
  SUPPORT_EMAIL: 45,
  SUPPORT_PHONE: 46,
  SUPPORT_URL: 73,
  TRANSFER_CONCIERGE: 116,
  BUSINESS_URL: 1513,
  BUSINESS_NOTES: 1514,
  MARKET: 594,
  DEFAULT_REGISTRATION: 270,
  DEFAULT_TLD: 400,
  HOSTING_NAMESERVERS: 7,
  PARKED_NAMESERVERS: 6,
  DEFAULT_NAMESERVERS: 21,

  GOOGLE_CONVERSIONS: 272,
  BING_CONVERSIONS: 283,
  YAHOO_CONVERSIONS: 273,
  GOOGLE_ANALYTICS: 271,

  CUSTOM_LINK_1_URL: 18,
  CUSTOM_LINK_1_TEXT: 28,
  CUSTOM_LINK_2_URL: 1509,
  CUSTOM_LINK_2_TEXT: 1510,
  CUSTOM_LINK_3_URL: 1511,
  CUSTOM_LINK_3_TEXT: 1512
};